import styled from 'styled-components';

export const StyledForm = styled.input.attrs(props => ({
  type: props.type,
  placeholder: props.placeholder
}))`
  border: 1px solid ${({ border }) => (border ? border : '#E6E6E6')};
  border-radius: ${({ rad }) => (rad ? rad : '4px')};
  width: ${({ width }) => (width ? width : '320px')};
  font-size: ${({ size }) => (size ? size : '14px')};
  padding: ${({ yxPadding }) => (yxPadding ? yxPadding : '10px 18px')};
  max-height: ${({ height }) => (height ? height : '40px')};
  margin-bottom: ${({ mb }) => (mb ? mb : '0px')};
  margin-left: ${({ ml, mx }) => ml ? ml : mx ? mx : '0'};
  margin-right: ${({ mr, mx }) => mr ? mr : mx ? mx : '0'};

  ::placeholder {
    font-size: 14px;
    color: ${({ border }) => (border ? border : '#E6E6E6')};;
  }

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.getRGBA(theme.mocaPurple, 0.8)};
    box-shadow: 0px 1px 1px ${({ theme }) => theme.getRGBA(theme.blackAbs, 0.075)} inset, 0px 1px 8px ${({ theme }) => theme.getRGBA(theme.mocaPurple, 0.6)};
    transition: .2s;
  }
`

export const StyledTxtArea = styled.textarea.attrs(props => ({
  rows: (props.rows ? props.rows : 4),
  placeholder: props.placeholder
}))`
  border: 1px solid ${({ border }) => (border ? border : '#E6E6E6')};
  border-radius: ${({ rad }) => (rad ? rad : '4px')};
  width: ${({ width }) => (width ? width : '320px')};
  font-size: ${({ size }) => (size ? size : '14px')};
  padding: ${({ yxPadding }) => (yxPadding ? yxPadding : '10px 18px')};
  margin-bottom: ${({ mb }) => (mb ? mb : '0px')};
  margin-left: ${({ ml, mx }) => ml ? ml : mx ? mx : '0'};
  margin-right: ${({ mr, mx }) => mr ? mr : mx ? mx : '0'};
  resize: none;

  ::placeholder {
    font-size: 14px;
    color: ${({ border }) => (border ? border : '#E6E6E6')};;
  }

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.getRGBA(theme.mocaPurple, 0.8)};
    box-shadow: 0px 1px 1px ${({ theme }) => theme.getRGBA(theme.blackAbs, 0.075)} inset, 0px 1px 8px ${({ theme }) => theme.getRGBA(theme.mocaPurple, 0.6)};
    transition: .2s;
  }
`

export const StyledSelect = styled.select`
  border: 1px solid ${({ border }) => (border ? border : '#E6E6E6')};
  border-radius: ${({ rad }) => (rad ? rad : '4px')};
  width: ${({ width }) => (width ? width : '320px')};
  font-size: ${({ size }) => (size ? size : '14px')};
  padding-left: 12px;
  padding-right: 40px;
  min-height: ${({ height }) => (height ? height : '40px')};
  margin-bottom: ${({ mb }) => (mb ? mb : '0px')};
  margin-left: ${({ ml, mx }) => ml ? ml : mx ? mx : '0'};
  margin-right: ${({ mr, mx }) => mr ? mr : mx ? mx : '0'};
  background: url(${require('App/assets/images/ic_arrow_down.png')}) ${({ arrowPos }) => arrowPos ? arrowPos : '96%'} / ${({ arrowSize }) => arrowSize ? arrowSize : '10%'} no-repeat;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  
  ::placeholder {
    font-size: 14px;
    color: ${({ border }) => (border ? border : '#E6E6E6')};
  }

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.getRGBA(theme.mocaPurple, 0.8)};
    box-shadow: 0px 1px 1px ${({ theme }) => theme.getRGBA(theme.blackAbs, 0.075)} inset, 0px 1px 8px ${({ theme }) => theme.getRGBA(theme.mocaPurple, 0.6)};
    transition: .2s;
  }
`

export const StyledTypeAhead = styled.div`
  & .rbt > .form-control > .rbt-input-wrapper > .rbt-input-hint-container {
    border: 1px solid ${({ border }) => (border ? border : '#E6E6E6')};
    border-radius: ${({ rad }) => (rad ? rad : '4px')};
    width: ${({ width }) => (width ? width : '320px')};
    font-size: ${({ size }) => (size ? size : '14px')};
    padding-left: 12px;
    padding-right: 12px;
    min-height: ${({ height }) => (height ? height : '40px')};
    margin-bottom: ${({ mb }) => (mb ? mb : '0px')};
    margin-left: ${({ ml, mx }) => ml ? ml : mx ? mx : '0'};
    margin-right: ${({ mr, mx }) => mr ? mr : mx ? mx : '0'};
  }
`

// CHECKBOX
export const CheckIcon = styled.svg`
  fill: none;
  stroke: ${({ theme }) => theme.mocaGreen};
  stroke-width: 4px;
`

export const CheckboxContainer = styled.div`
  cursor: pointer;
  display: inline-block;
  vertical-align: middle;
`

export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`

export const StyledCheckbox = styled.div`
  display: inline-block;
  width: 16px;
  height: 16px;
  background: ${({ theme, disable }) => disable ? theme.getRGBA(theme.blackAbs, 0.08) : theme.white};
  border-radius: 3px;
  border: 1px solid #B4BFC9;
  box-shadow: 0 1px 3px 0 ${({ theme }) => theme.getRGBA(theme.blackAbs, 0.08)};
  transition: all 150ms;

  ${CheckIcon} {
    visibility: ${({ checked }) => checked ? 'visible' : 'hidden'};
    box-shadow: 0 1px 3px 0 ${({ theme }) => theme.getRGBA(theme.mocaGreen, 0.08)};
  }
`
export const StyledNumberForm = styled.input.attrs(props => ({
  type: 'text',
  placeholder: props.placeholder
}))`
  border: 1px solid ${({ border }) => (border ? border : '#E6E6E6')};
  border-radius: ${({ rad }) => (rad ? rad : '4px')};
  width: ${({ width }) => (width ? width : '320px')};
  font-size: ${({ size }) => (size ? size : '14px')};
  padding: ${({ yxPadding }) => (yxPadding ? yxPadding : '10px 18px')};
  max-height: ${({ height }) => (height ? height : '40px')};
  margin-bottom: ${({ mb }) => (mb ? mb : '0px')};
  margin-left: ${({ ml, mx }) => ml ? ml : mx ? mx : '0'};
  margin-right: ${({ mr, mx }) => mr ? mr : mx ? mx : '0'};
  text-align: ${({ alignRight }) => (alignRight ? 'right' : 'left')};
  
  position: relative;
  background-image: ${({ allowNegative, negative }) => allowNegative ? negative ? `url(${require('App/assets/images/ic_minus.png')})` : `url(${require('App/assets/images/ic_plus_bk.png')})` : ''};
  background-repeat: no-repeat;
  background-position: 10px center;
  background-size: 10px;
  padding-left: ${({ allowNegative }) => allowNegative ? '30px' : ''};
  box-sizing: border-box;

  ::placeholder {
    font-size: 14px;
    color: ${({ border }) => (border ? border : '#E6E6E6')};;
  }

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.getRGBA(theme.mocaPurple, 0.8)};
    box-shadow: 0px 1px 1px ${({ theme }) => theme.getRGBA(theme.blackAbs, 0.075)} inset, 0px 1px 8px ${({ theme }) => theme.getRGBA(theme.mocaPurple, 0.6)};
    transition: .2s;
  }
`
export const SwitchInput = styled.input`
  height: 0;
  width: 0;
  visibility: hidden;
`;

export const SwitchLabel = styled.label`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  width: 30px;
  height: 16px;
  margin-bottom: 0px;
  margin-right: ${({ marginRight }) => marginRight ? marginRight : '0px'};
  border-radius: 100px;
  border: 2px solid ${({ theme }) => theme.mocaPurple};
  position: relative;
  transition: background-color 0.2s;
`;

export const SwitchButton = styled.span`
  content: "";
  position: absolute;
  left: -2px;
  width: 16px;
  height: 16px;
  border-radius: 100px;
  transition: 0.2s;
  border: 2px solid ${({ theme }) => theme.mocaPurple};
  box-shadow: 0 0 2px 0 rgba(10, 10, 10, 0.29);
  ${SwitchInput}:checked + ${SwitchLabel} & {
    background: ${({ theme }) => theme.mocaPurple};
    transform: translateX(calc(100% - 2px));
  }
`;

export const StepperButton = styled.button`
  background-color: #F1F1F1;
  border: 1px solid #F1F1F1;
  border-radius: ${({ rad }) => (rad ? rad : '2px')};
  color: #505050;
  font-size: 10px;
  line-height: 8px;
  text-align: center;

  &:hover {
    background-color: #D2D2D2;
    border-color: #D2D2D2;
    cursor: pointer;
  }

  &:focus {
    outline: none;
    box-shadow: none;
  }
`

export const StyledFormContainer = styled.div`
  position: relative;
`

export const StepperButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 50%;
  right: 0;
  transform: translate(-50%, -65%);
`